module.exports = __webpack_public_path__ + "img/clear.27077e1a.png";